var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick_success_",
    "data-name": "Tick success ",
    transform: "translate(-704 -1572)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7,
    cy: 7,
    rx: 7,
    ry: 7,
    transform: "translate(704 1572)",
    fill: "#028746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M8.8,68.128a.448.448,0,0,0-.631,0L2.818,73.445.762,71.4a.448.448,0,0,0-.631,0,.442.442,0,0,0,0,.628L2.5,74.386a.448.448,0,0,0,.631,0L8.8,68.755A.442.442,0,0,0,8.8,68.128Z",
    transform: "translate(706.536 1507.833)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectFilledIcon);
export default __webpack_public_path__ + "static/media/correct-filled-icon.33be3e5fbd15b2cb857dec1b9829ccdb.svg";
export { ForwardRef as ReactComponent };